import { defineMessages } from 'react-intl';

export const fieldErrorMessageDefinitions = defineMessages({
  required: {
    id: 'fieldError.required',
    defaultMessage: 'Required',
  },
  wrongValue: {
    id: 'fieldError.wrongValue',
    defaultMessage: 'Wrong value',
  },
  maxLength: {
    id: 'fieldError.maxLength',
    defaultMessage: 'Text exceeded maximum limit of characters',
  },
});
